module.exports = __webpack_public_path__ + "assets/img/profile2.8f98afdb.jpg";